import {
  PLATFORM_MAIN_HOSTS,
  PLATFORM_BASE,
  KNOWN_CUSTOM_DOMAINS,
} from "../config/domains";

/** Check if running in dev/preview environment */
export function isDevOrPreview() {
  const h = window.location.hostname;
  return h === 'localhost' || h === '127.0.0.1';
}

/** Extract tenant slug + subpath from URL path (/t/{slug}/...) */
export function detectTenantFromPath() {
  const match = window.location.pathname.match(/^\/t\/([a-z0-9-]+)(\/.*)?$/);
  if (!match) return null;
  return { slug: match[1], subpath: match[2] || '/' };
}

/** Resolve tenant slug from hostname (subdomain or custom domain) */
export function detectTenantSlugFromHost() {
  const hostname = window.location.hostname;
  if (PLATFORM_MAIN_HOSTS.includes(hostname)) return null;
  if (KNOWN_CUSTOM_DOMAINS[hostname]) return KNOWN_CUSTOM_DOMAINS[hostname];
  if (hostname.endsWith(`.${PLATFORM_BASE}`)) {
    const slug = hostname.replace(`.${PLATFORM_BASE}`, '');
    if (slug && !slug.includes('.')) return slug;
  }
  return null;
}

/** Check if current host is a custom domain (not platform, not dev) */
export function isCustomDomainHost() {
  const hostname = window.location.hostname;
  return !PLATFORM_MAIN_HOSTS.includes(hostname) &&
    !hostname.endsWith(`.${PLATFORM_BASE}`) &&
    hostname !== 'localhost' &&
    hostname !== '127.0.0.1';
}
